
import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Payment } from './types';
import { ExportButton } from './payments/ExportButton';
import { PaymentRow } from './payments/PaymentRow';
import { PaymentTableHeader } from './payments/PaymentTableHeader';

interface PaymentsTableProps {
  payments: Payment[];
  loading: boolean;
}

export const PaymentsTable = ({ payments, loading }: PaymentsTableProps) => {
  return (
    <div className="rounded-md border bg-card">
      <div className="p-4 flex justify-between items-center border-b">
        <h3 className="text-lg font-medium">Payment History</h3>
        <ExportButton payments={payments} loading={loading} />
      </div>
      <Table>
        <PaymentTableHeader />
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center">Loading...</TableCell>
            </TableRow>
          ) : payments.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center">No payments found</TableCell>
            </TableRow>
          ) : (
            payments.map((payment, index) => (
              <PaymentRow key={index} payment={payment} />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};
